import { render } from "./DateForm.vue?vue&type=template&id=72e444a4&scoped=true"
import script from "./DateForm.vue?vue&type=script&lang=js"
export * from "./DateForm.vue?vue&type=script&lang=js"

import "./DateForm.vue?vue&type=style&index=0&id=72e444a4&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e444a4"]])

export default __exports__